import { render } from "./kongqiulv.vue?vue&type=template&id=f5cca564&scoped=true"
import script from "./kongqiulv.vue?vue&type=script&lang=js"
export * from "./kongqiulv.vue?vue&type=script&lang=js"

import "./kongqiulv.vue?vue&type=style&index=0&id=f5cca564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5cca564"]])

export default __exports__